const referralApi = '/referral';

export const submitReferralPath = () => `${referralApi}`;
export const declineReferralPath = () => `${referralApi}/decline`;
export const loginReferralPath = () => `${referralApi}/login`;
export const fetchReferrerProfilePath = () => `${referralApi}/profile`;
